import './style.css';
import { mountApp } from './app';

const root = document.querySelector<HTMLElement>('#app');
if (!root) {
  throw new Error('#app 根节点不存在');
}
mountApp(root);
